import { render, staticRenderFns } from "./dados-empresa.vue?vue&type=template&id=28c99270&"
import script from "./dados-empresa.vue?vue&type=script&lang=js&"
export * from "./dados-empresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports